/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Form_TitleInputs */

const en_directory_submit_content_form_title = /** @type {(inputs: Directory_Submit_Content_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing details`)
};

const zh_directory_submit_content_form_title = /** @type {(inputs: Directory_Submit_Content_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录详情`)
};

/**
* | output |
* | --- |
* | "Listing details" |
*
* @param {Directory_Submit_Content_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_form_title = /** @type {((inputs?: Directory_Submit_Content_Form_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Form_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_form_title(inputs)
	return zh_directory_submit_content_form_title(inputs)
});
export { directory_submit_content_form_title as "directory.submit.content.form_title" }